
import { styled, Paper } from '@mui/material';
import Drawer from '@mui/material/Drawer';
import { MenuList } from '@mui/material'

export const CustomNavbarDrawer = styled(Drawer)({
    "& .MuiPaper-root": {
        width: "500px",
        backgroundColor: "#19293C",

        "@media (max-width:768px)": {
            width: "100%",
        }
    }

})

export const SubLinkList = styled(MenuList)({
    padding: 0,

    ".MuiMenuItem-root": {
        padding: "15px 16px 10px 15px !important",
        backgroundColor: "transparent",
        fontFamily: "Montserrat",
        display: "flex",
        alignItems: "center",
        justifyContent: "start",
        whiteSpace: "normal",
        minHeight: "20px",


        "@media (max-width:768px)": {
            fontSize: "14px"
        },
        "& .MuiLink-root": {
            textDecoration: "none",
            color: "#ffffff99",

            "&.active": {
                color: "#006EFF"
            }
        },

        "&:hover": {
            backgroundColor: "transparent",

            "& .MuiLink-root": {
                color: "#006EFF"
            },
        },
    }
})

export const FooterLanguagePaper = styled(Paper)({
    marginBottom: "6px",
    backgroundColor: "#19293C",
    borderRadius: "6px",
    border: "1px solid #ffffff4d",

    "& .MuiList-root": {
        borderRadius: "6px",
        padding: "0",

        "& .MuiMenuItem-root": {
            fontSize: "14px",
            padding: "12px 20px",
            fontFamily: "Montserrat",

            "& .MuiLink-root": {
                textDecoration: "none",
                color: "#ffffff99"
            },

            "&:hover": {
                "& .MuiLink-root": {
                    color: "#006EFF"
                }
            }
        }
    }

})